import styled from 'styled-components';

const Container = styled.div`
  padding: 0 32px 32px 32px;
  display: flex;
  align-items: center;
  flex-direction: column;
  color: var(--text-text02);

  span.contentTitle {
    font-weight: 900;
    font-size: 20px;
    line-height: 32px;
    margin: 20px 0px 16px 0px;
    text-align: center;
  }
  span.span-highlight {
    font-weight: 700;
    color: var(--nb-primary);
  }
  p.contentSubtitle {
    text-align: center;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
  }
  p.contentSubtitle0 {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 8px;
  }
  div.contentInfo {
    background: #ecf4f9;
    border-radius: 8px;
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    margin-top: 16px;
  }
  div.contentInfo cc-icon {
    margin-right: 8px;
  }
  span.contentInfoText {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
  }
  button.contentButton {
    width: 100%;
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
    background-color: var(--nb-primary);
    padding: 10px 16px;
    color: #ffffff;
    border-radius: 4px;
    margin-top: 24px;
  }
  button.contentButton:hover {
    background-color: var(--primary-hover);
  }
  button.contentButton:active,
  button.contentButton:focus {
    background-color: var(--primary-focus);
  }

  .goToWhatsapp {
    color: #5b36f2;
  }

  @media (min-width: 768px) {
    button.contentButton {
      white-space: nowrap;
      padding: 12px 24px;
      width: auto;
    }
  }
`;

export { Container };
